module.exports = __webpack_public_path__ + "static/media/flamingo2.2e9fccc2.png";